/** Mapping 1:1 pour réutiliser l'import CSV (clés ligne = clés mapping). */
export const ENTREPRISE_GOUV_IMPORT_MAPPING = {
  fullName: 'fullName',
  company: 'company',
  siret: 'siret',
  ape: 'ape',
  address: 'address',
  postalCode: 'postalCode',
  city: 'city',
};

export function entreprisePreviewToImportRow(p) {
  return {
    fullName: p.fullName || '',
    company: p.company || '',
    siret: p.siret || '',
    ape: p.ape || '',
    address: p.address || '',
    postalCode: p.postalCode || '',
    city: p.city || '',
  };
}
